class TC_Testimonials {
    constructor () {
        if ($('.pricing-testimonials').length) {
            this.initEvents();
        }
    }

    initEvents () {
        let btn = $('.pricing-testimonials-show-more');
        let items = $('.pricing-testimonials-item');

        if (btn.length) {
            btn.on('click', e => {
                e.preventDefault();
                let hiddenItems = $('.pricing-testimonials-item.is-hidden');

                if (hiddenItems.length) {
                    for (let i = 0; i < 3; i++) {
                        if (!hiddenItems[i]) {
                            break;
                        }

                        this.animateItem(hiddenItems.eq(i));
                    }
                }

                setTimeout(() => {
                    if (!$('.pricing-testimonials-item.is-hidden').length) {
                        btn.addClass('is-hidden');
                    }
                }, 50);
            });
        }
    }

    animateItem (item) {
        item.removeClass('is-hidden').addClass('is-to-show');

        setTimeout(() => {
            item.removeClass('is-to-show');
        }, 25);
    }
}
